module.exports = __webpack_public_path__ + "img/guide10.bcf0d1b1.png";